"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var TakingPictures = function TakingPictures(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6244 0.00716485 23.9928 5.37555 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM4.5 14.5C4.5 15.6046 5.39543 16.5 6.5 16.5H17.5C18.6046 16.5 19.5 15.6046 19.5 14.5V9.5C19.5 8.39543 18.6046 7.5 17.5 7.5H16C15.8162 7.48311 15.6419 7.41094 15.5 7.293L14.207 6C13.8778 5.69379 13.4493 5.51631 13 5.5H11C10.5507 5.51631 10.1222 5.69379 9.793 6L8.5 7.293C8.35808 7.41094 8.18376 7.48311 8 7.5H6.5C5.39543 7.5 4.5 8.39543 4.5 9.5V14.5Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z",
    fill: fill
  }));
};
TakingPictures.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
TakingPictures.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = TakingPictures;